import { cx } from '@clutch-creator/bridge';

export default (props, vars) =>
  cx(
    vars?.['defaultbox145']?.['item']?.['status'] === 'LOCKED' && 'locked',
    vars?.['defaultbox145']?.['item']?.['empty'] && 'empty'
  );
